import React from "react";
import "./CSS/OurClients.css";

/*  📌  Replace these URLs with real logo files in
        src/Components/Assets/ or a CDN.
*/
const CLIENT_LOGOS = [
  { id: 1, src: "https://cache.marriott.com/content/dam/marriott-digital/jw/global-property-shared/en_us/logo/assets/jw_logo_L.png", alt: "Client 1" },
  { id: 2, src: "https://swandolphin.com/wp-content/uploads/2025/03/BourbonSteak-brand_full-logo_K-768x389.png", alt: "Client 2" },
  { id: 3, src: "https://selfservice.southernglazers.com/images/logos/mobile/sgws-black-1000x250.png", alt: "Client 3" },
  { id: 4, src: "https://patekboutiquemiami.com/wp-content/uploads/2021/05/patekphilippe_01-1_logotype_pms_color_pos_6710_0-2.svg", alt: "Client 4" },
  { id: 5, src: "https://media.licdn.com/dms/image/sync/v2/D4E27AQHuEyflKisFoA/articleshare-shrink_800/articleshare-shrink_800/0/1729203358050?e=2147483647&v=beta&t=s9RrFgklTAd5T-OW0f2KZ4-FwCf8xjw9ozP8k1DT3a0", alt: "Client 5" },
  { id: 6, src: "https://i.ibb.co/dJ5YyjGM/Vinotie-All-Clients.jpg", alt: "Client 6" },
];

export default function OurClients() {
  return (
    <section className="ourclients">
      <header className="ourclients-header">
        <h1>Our Clients</h1>
        <p>
          We’re proud to partner with forward-thinking brands that share our
          passion for quality and innovation.
        </p>
      </header>

      <div className="ourclients-grid">
        {CLIENT_LOGOS.map(({ id, src, alt }) => (
          <figure key={id} className="client-card">
            <img src={src} alt={alt} loading="lazy" />
          </figure>
        ))}
      </div>
    </section>
  );
}
